//TODO: This should be wrapped in an ht.declare() probably
// IE is poor at dealing with area and map, so only do so when needed
if ($('img[usemap]').length > 0) {
  $('map area[href]').each(function () {
    $(this).attr('href', ht.setSessionUrl($(this).attr('href')));
  });
}
